import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const jumpToTop = () => {
  const html = document.documentElement;
  // JS behavior:"auto" follows CSS; Bootstrap html { scroll-behavior: smooth }
  // would then animate from the previous page offset. Force an instant jump.
  html.style.scrollBehavior = "auto";
  window.scrollTo(0, 0);
  const scrolling = document.scrollingElement;
  if (scrolling) scrolling.scrollTop = 0;
  html.scrollTop = 0;
  document.body.scrollTop = 0;
  const studioMain = document.querySelector(".hkp-studio-main");
  if (studioMain instanceof HTMLElement) {
    studioMain.scrollTop = 0;
  }
};

const restoreSmoothScroll = () => {
  document.documentElement.style.scrollBehavior = "";
};

/**
 * Public pages share the window scroller. Without an instant reset, a long home
 * page leaves Studio / My Collection parked at the bottom of the next route.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    window.history.scrollRestoration = "manual";

    if (hash) {
      restoreSmoothScroll();
      const id = decodeURIComponent(hash.replace(/^#/, ""));
      const el = id ? document.getElementById(id) : null;
      if (el) {
        el.scrollIntoView();
        return;
      }
    }

    const active = document.activeElement;
    if (active instanceof HTMLElement) {
      active.blur();
    }
    jumpToTop();
    const frame = window.requestAnimationFrame(jumpToTop);
    const later = window.setTimeout(() => {
      jumpToTop();
      restoreSmoothScroll();
    }, 50);
    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(later);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
